import { DeviceCategory, isDeviceGateway, VelavuDevice } from "velavu-js-api";

export enum DeviceType {
	Tag,
	Anchor,
	Gateway,
}

/**
 * Resolves the effective device type of a device
 */
export function resolveDeviceType(device: VelavuDevice): DeviceType | null {
	if (device.category === DeviceCategory.Anchor) {
		//If a device's category is ANCHOR, it is always an anchor
		return DeviceType.Anchor;
	} else if (device.asset !== undefined) {
		//If a device has an asset, it is a tag
		return DeviceType.Tag;
	} else if (isDeviceGateway(device)) {
		//Vesta devices are gateways if their category is TAG
		return DeviceType.Gateway;
	} else {
		//Invalid
		return null;
	}
}
